import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { IBroadcast } from "interfaces";
import { Custom, Item, Modal, Progress } from "components";
import { Box } from "@mui/material";
import { Enums, Helpers, Store } from "utils";

type Props = {
  opened: boolean;
  onOpen: () => void;
  onClose?: () => void;
  // TODO: it may be improved (currently being used to force the updated of the appointments)
  incrementComponent?: number;
};

export const Reminder = (props: Props) => {
  const { t, service } = useApp();

  const [reminders, setReminders] = useState<IBroadcast[]>([]);

  useEffect(() => {
    findReminders();
  }, [props.incrementComponent]);

  const isClinic = Store.sessionStorage.isClinic();

  const findReminders = async () => {
    const response = await service.broadcast.slice(
      Enums.EnumBroadcastType.Reminder
    );
    setReminders(response);
  };

  const handleAction = async (broadcast: IBroadcast) => {
    isClinic
      ? await service.broadcast.delete(broadcast.broadcastId)
      : await service.broadcast.update(broadcast.broadcastId, true);
    findReminders();
    props.onClose && props.onClose();
  };

  return (
    <Custom.Card
      sx={{ height: 305 }}
      title={t.title.reminder}
      action={
        <>
          <Custom.Button size="small" variant="outlined" onClick={props.onOpen}>
            {t.action.view_all}
          </Custom.Button>
          <Modal.Reminder
            opened={props.opened}
            onClose={props.onClose}
            items={reminders}
          />
        </>
      }
    >
      <Box sx={{ position: "relative" }}>
        {reminders ? (
          reminders.length > 0 ? (
            reminders.map((item: IBroadcast) => (
              <Item.Broadcast
                key={item.broadcastId}
                item={item}
                action={true}
                onAction={() => handleAction(item)}
              />
            ))
          ) : (
            <Progress.NoRecord
              height={200}
              message={t.message.placeholder.no_reminder}
            />
          )
        ) : (
          Helpers.generateArray(4).map((_, i) => (
            <Progress.PlaceholderItem key={i} />
          ))
        )}
      </Box>
    </Custom.Card>
  );
};
